import { createSlice } from "@reduxjs/toolkit";

const diamondPointSlice = createSlice({
  name: "diamondPoint",
  initialState: {
    loading: false,
    data: null,
    error: null,
    pendingOrder: null,
  },

  reducers: {
    createDiamondPointOrderRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    createDiamondPointOrderSuccess: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    createDiamondPointOrderFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    getDiamondPendingOrderRequest: (state) => {
      state.loading = true;
      state.error = null;
      state.pendingOrder = null;
    },
    getDiamondPendingOrderSuccess: (state, action) => {
      state.loading = false;
      state.pendingOrder = action.payload;
    },
    getDiamondPendingOrderFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.pendingOrder = null;
    },
    cancelDiamondPointOrderRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    cancelDiamondPointOrderSuccess: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    cancelDiamondPointOrderFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  createDiamondPointOrderRequest,
  createDiamondPointOrderSuccess,
  createDiamondPointOrderFailure,
  getDiamondPendingOrderRequest,
  getDiamondPendingOrderSuccess,
  getDiamondPendingOrderFailure,
  cancelDiamondPointOrderRequest,
  cancelDiamondPointOrderSuccess,
  cancelDiamondPointOrderFailure,
} = diamondPointSlice.actions;

export default diamondPointSlice.reducer;
